export default __webpack_public_path__ + "static/media/T165MANE5.b58b14b6.pdf";